(function () {
  var DAYS = {
    'marti': 'Marți', 'miercuri': 'Miercuri', 'joi': 'Joi', 'vineri': 'Vineri',
    'miercuri/joi': 'Miercuri sau Joi', 'joi/vineri': 'Joi sau Vineri',
    'zilnic': 'Zilnic (luni–vineri)'
  };
  function fmt(d) { return DAYS[d] || d; }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  var DATA = {
    'Alba': [{ c: 'miercuri', r: 'joi' }],
    'Arad': [{ n: 'Săvârșin, Lipova', c: 'miercuri', r: 'miercuri' }, { n: 'Arad', c: 'joi', r: 'joi' }, { n: 'Chișineu Criș, Ineu, Brad', c: 'vineri', r: 'vineri' }],
    'Argeș': [{ n: 'Pitești, Mioveni, Curtea de Argeș', c: 'miercuri', r: 'miercuri' }, { n: 'Câmpulung, Rucăr', c: 'vineri', r: 'vineri' }],
    'Bacău': [{ n: 'Bacău', c: 'vineri', r: 'vineri' }, { n: 'Onești, Moinești, Comănești', c: 'miercuri', r: 'miercuri' }],
    'Bihor': [{ c: 'miercuri', r: 'joi' }],
    'Bistrița-Năsăud': [{ c: 'miercuri', r: 'joi' }],
    'Botoșani': [{ c: 'joi', r: 'joi' }],
    'Brașov': [{ n: 'Brașov', c: 'miercuri/joi', r: 'miercuri/joi' }, { n: 'Făgăraș, Victoria', c: 'miercuri', r: 'miercuri' }, { n: 'Predeal', c: 'miercuri', r: 'miercuri' }],
    'Brăila': [{ c: 'vineri', r: 'vineri' }],
    'București': [{ c: 'zilnic', r: 'zilnic' }],
    'Buzău': [{ c: 'miercuri', r: 'miercuri' }],
    'Caraș-Severin': [{ c: 'miercuri', r: 'miercuri' }],
    'Călărași': [{ c: 'miercuri', r: 'miercuri' }],
    'Cluj': [{ c: 'marti', r: 'miercuri/joi' }],
    'Constanța': [{ c: 'marti', r: 'marti' }, { c: 'joi', r: 'joi' }, { c: 'vineri', r: 'vineri' }],
    'Covasna': [{ c: 'miercuri', r: 'miercuri' }],
    'Dâmbovița': [{ c: 'vineri', r: 'vineri' }],
    'Dolj': [{ c: 'miercuri/joi', r: 'miercuri/joi' }],
    'Galați': [{ c: 'vineri', r: 'vineri' }],
    'Giurgiu': [{ n: 'oraș Giurgiu', c: 'miercuri', r: 'miercuri' }, { n: 'Bolintin Vale/Deal, Mihăilești', c: 'joi', r: 'joi' }, { n: 'Bragadiru', c: 'zilnic', r: 'zilnic' }],
    'Gorj': [{ c: 'joi', r: 'joi' }],
    'Harghita': [{ c: 'joi', r: 'joi' }],
    'Hunedoara': [{ c: 'joi/vineri', r: 'joi/vineri' }],
    'Ialomița': [{ c: 'miercuri', r: 'miercuri' }],
    'Iași': [{ c: 'miercuri', r: 'miercuri' }],
    'Ilfov': [{ n: 'Snagov, Moara Vlăsiei, zona Nord', c: 'marti', r: 'marti' }, { n: '1 Decembrie, Berceni, Vidra', c: 'joi', r: 'joi' }, { n: 'Brănești', c: 'joi', r: 'joi' }],
    'Maramureș': [{ c: 'miercuri', r: 'joi' }],
    'Mehedinți': [{ c: 'miercuri', r: 'miercuri' }],
    'Mureș': [{ c: 'miercuri', r: 'joi' }],
    'Neamț': [{ c: 'marti', r: 'marti' }, { c: 'vineri', r: 'vineri' }],
    'Olt': [{ c: 'joi', r: 'joi' }],
    'Prahova': [{ n: 'Ploiești', c: 'vineri', r: 'miercuri' }, { n: 'Boldești-Scăeni, Vălenii de Munte, Măneciu', c: 'miercuri', r: 'miercuri' }, { n: 'Băicoi, Câmpina, Comarnic, Sinaia, Bușteni', c: 'miercuri', r: 'miercuri' }],
    'Sălaj': [{ c: 'miercuri', r: 'joi' }],
    'Satu Mare': [{ c: 'miercuri', r: 'joi' }],
    'Sibiu': [{ c: 'miercuri/joi', r: 'miercuri/joi' }],
    'Suceava': [{ c: 'joi', r: 'joi' }],
    'Teleorman': [{ c: 'joi', r: 'joi' }],
    'Timiș': [],
    'Tulcea': [{ c: 'miercuri', r: 'miercuri' }],
    'Vaslui': [{ c: 'joi', r: 'joi' }],
    'Vâlcea': [{ n: 'Râmnicu Vâlcea', c: 'miercuri/joi', r: 'miercuri/joi' }, { n: 'Horezu', c: 'joi', r: 'joi' }, { n: 'Drăgășani', c: 'joi', r: 'joi' }],
    'Vrancea': [{ c: 'miercuri', r: 'miercuri' }]
  };
  var FREE = { 'București': true, 'Ilfov': true };
  // București & Ilfov: own refrigerated vans; delivery day confirmed by SMS. No date estimate.
  var SMS_ZONES = { 'București': true, 'Ilfov': true };
  var COUNTIES = Object.keys(DATA);
  var OFFSET = { luni: 0, marti: 1, miercuri: 2, joi: 3, vineri: 4 };

  function roNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Bucharest' })); }
    catch (e) { return new Date(); }
  }
  function deliveryMonday(now) {
    var d = new Date(now);
    var dow = d.getDay();
    if (dow === 1 && d.getHours() < 22) { d.setHours(0, 0, 0, 0); return d; }
    var add = (8 - dow) % 7;
    if (add === 0) add = 7;
    d.setDate(d.getDate() + add);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function weekMonday(now) {
    var d = new Date(now);
    var dow = d.getDay();
    var diff = dow === 0 ? 6 : dow - 1;
    d.setDate(d.getDate() - diff);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function fmtDate(d) {
    return d.toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' });
  }
  function datesText(token, monday) {
    return token.split('/').map(function (t) {
      var off = OFFSET[t];
      if (off === undefined) return fmt(t);
      var d = new Date(monday);
      d.setDate(d.getDate() + off);
      return fmtDate(d);
    }).join(' sau ');
  }

  function buildResult(county) {
    var zones = DATA[county];

    // București & Ilfov: livrare cu mașinile proprii, ziua confirmată prin SMS. Fără estimare de dată.
    if (SMS_ZONES[county]) {
      var h = '';
      h += '<p class="dc-headline">🚚 În <strong>' + county + '</strong> livrăm garantat <strong>în aceeași săptămână</strong>, cu mașinile noastre frigorifice.</p>';
      h += '<p class="dc-line">📱 După împachetarea comenzii primești un <strong>SMS</strong> prin care îți confirmăm ziua de livrare. Dacă preferi altă zi, ne poți răspunde la SMS cu ziua dorită.</p>';
      if (FREE[county]) {
        h += '<p class="dc-free">✅ Transport <strong>GRATUIT</strong> la comenzi peste 300 lei.</p>';
      }
      return h;
    }

    var now = roNow();
    var refMon = deliveryMonday(now);
    var thisWeek = refMon.getTime() === weekMonday(now).getTime();
    var weekLabel = thisWeek ? 'săptămâna aceasta' : 'săptămâna viitoare';
    var pureZilnic = zones && zones.length === 1 && zones[0].c === 'zilnic';
    var html = '';

    if (!zones || zones.length === 0) {
      html += '<p class="dc-line">Pentru <strong>' + county + '</strong> îți confirmăm ziua exactă telefonic / pe WhatsApp.</p>';
    } else if (pureZilnic) {
      html += '<p class="dc-headline">📦 Livrare <strong>zilnic (luni–vineri)</strong> — comanda pleacă în cea mai apropiată zi lucrătoare.</p>';
    } else {
      var named = zones.some(function (z) { return z.n; });
      if (!named && zones.length > 1) {
        var days = [];
        zones.forEach(function (z) { var f = fmt(z.c); if (days.indexOf(f) < 0) days.push(f); });
        html += '<p class="dc-headline">📦 Livrare: <strong>' + days.join(', ') + '</strong> <span class="dc-muted">(în funcție de rută)</span> — <strong>' + weekLabel + '</strong></p>';
      } else {
        html += '<p class="dc-headline">📦 Comanda ta ajunge (<strong>' + weekLabel + '</strong>):</p>';
        zones.forEach(function (z) {
          var label = z.n ? '<span class="dc-zone">' + z.n + ':</span> ' : '';
          if (z.c === 'zilnic') {
            html += '<p class="dc-line">' + label + '<strong>zilnic (luni–vineri)</strong></p>';
          } else if (z.c === z.r) {
            html += '<p class="dc-line">' + label + '<strong>' + cap(datesText(z.c, refMon)) + '</strong></p>';
          } else {
            html += '<p class="dc-line">' + label + 'congelate: <strong>' + cap(datesText(z.c, refMon)) + '</strong> · proaspete: <strong>' + cap(datesText(z.r, refMon)) + '</strong></p>';
          }
        });
      }
    }

    if (FREE[county]) {
      html += '<p class="dc-free">🚚 Transport <strong>GRATUIT</strong> la comenzi peste 300 lei.</p>';
    }
    if (!pureZilnic && zones && zones.length) {
      html += '<p class="dc-note">* Zilele se pot decala în săptămânile cu sărbători.</p>';
    }
    return html;
  }

  class DeliveryDayChecker extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-dc-select]');
      this.result = this.querySelector('[data-dc-result]');
      this.cutoff = this.querySelector('.delivery-checker__cutoff');
      if (!this.select || this._init) return;
      this._init = true;
      var frag = document.createDocumentFragment();
      COUNTIES.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c; o.textContent = c;
        frag.appendChild(o);
      });
      this.select.appendChild(frag);
      var saved = null;
      try { saved = localStorage.getItem('cochilia_judet'); } catch (e) {}
      if (saved && DATA[saved]) { this.select.value = saved; this.show(saved); }
      var self = this;
      this.select.addEventListener('change', function () {
        var v = self.select.value;
        try { if (v) localStorage.setItem('cochilia_judet', v); } catch (e) {}
        if (v) { self.show(v); } else { self.result.hidden = true; if (self.cutoff) self.cutoff.style.display = ''; }
      });
    }
    show(county) {
      this.result.innerHTML = buildResult(county);
      this.result.hidden = false;
      if (this.cutoff) {
        var zones = DATA[county];
        var pureZilnic = zones && zones.length === 1 && zones[0].c === 'zilnic';
        var hide = !!SMS_ZONES[county] || pureZilnic;
        this.cutoff.style.display = hide ? 'none' : '';
      }
    }
  }
  if (!customElements.get('delivery-day-checker')) {
    customElements.define('delivery-day-checker', DeliveryDayChecker);
  }
})();